import Controller from '@ember/controller';

export default class RoadmapTableInitiativeWorkstreamsWorkstreamArchiveController extends Controller {
  visibleBadges = ['teams', 'weeks'];
}
